/**
 * Host-app routes that mount the Open Knots microfrontend.
 * Keep aligned with child routes in 129knots-openknots-ui (App.jsx).
 */
export const OPEN_KNOTS_HOST_PATHS = [
    '/suppliers',
    '/addSuppliers',
    '/editSuppliersOpenKnots',
    '/profile',
    '/settings',
    '/createRfqOpenKnots',
    '/supplierResponseOpenKnots',
    '/RfqDetailsOpenKnots',
];

export const isOpenKnotsHostPath = (pathname) =>
    OPEN_KNOTS_HOST_PATHS.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

/** True on every host screen that renders Open Knots: MFE routes plus the OPEN dashboard tab. */
export const isOpenKnotsHostRoute = (pathname, search = '') => {
    if (isOpenKnotsHostPath(pathname)) {
        return true;
    }
    if (pathname === '/dashboard' || pathname.startsWith('/dashboard/')) {
        return new URLSearchParams(search).get('type') === 'openKnots';
    }
    return false;
};

/** Buyer BAAS and Trade Support dashboard tabs share the OPEN header bar. */
export const isKnotProductDashboardRoute = (pathname, search = '') => {
    if (pathname !== '/dashboard' && !pathname.startsWith('/dashboard/')) {
        return false;
    }
    const type = new URLSearchParams(search).get('type');
    return type === 'marketPlace' || type === 'payable';
};

/** OPEN screens plus the BAAS and Trade Support dashboard tabs. */
export const shouldUseKnotDashboardHeader = (pathname, search = '') =>
    isOpenKnotsHostRoute(pathname, search) || isKnotProductDashboardRoute(pathname, search);

/**
 * Bare `/dashboard` renders BAAS before the URL gains `?type=`. Buyer, supplier, and
 * broker-with-buyer should get the new header on that first paint, not after a tab click.
 */
export const shouldUseKnotDashboardHeaderForRole = (
    pathname,
    search = '',
    role,
    { hasAssociatedBuyer = false } = {},
) => {
    if (shouldUseKnotDashboardHeader(pathname, search)) {
        return true;
    }
    const onBareDashboard = pathname === '/dashboard' || pathname === '/dashboard/';
    const type = new URLSearchParams(search).get('type');
    if (!onBareDashboard || type) {
        return false;
    }
    return role === 'buyer' || role === 'supplier' || (role === 'broker' && hasAssociatedBuyer);
};

/** Hide Suppliers / Ports / credit in the host header on OPEN, BAAS, and Trade Support. */
export const shouldHideHostHeaderOrgStatistics = (pathname, search = '') =>
    shouldUseKnotDashboardHeader(pathname, search);
